import LockTableRow from "./LockTableRow";

export default class DetailsRow extends LockTableRow {
    constructor(){
        super();
        this.parentRow = null;
    }

    setParentRow(parentRow)
    {
        this.parentRow = parentRow;
    }

    getParentRow()
    {
        return this.parentRow;
    }

    accept(visitor, cell)
    {
        return visitor.visitDetailsRow(cell);
    }

    isFirstChildRow()
    {
        return this.getParentRow().getChildRows()[0].getRowIdx() == this.getRowIdx();
    }

    isLastChildRow()
    {
        let childRows = this.getParentRow().getChildRows();
        return childRows[childRows.length - 1].getRowIdx() == this.getRowIdx();
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/DetailsRow.js